import { Form, message } from 'antd';
import { useEffect } from 'react';

import SocialLinksForm from '../../forms/SocialLinksForm';
import { AddInfoContentService, GetInfoContentService } from '../../services/infoContentServices';
import useTranslation from '../../../hooks/translation/useTranslation';

function SocialLinks() {
  const { trans } = useTranslation();
  const [form] = Form.useForm();

  const fetchData = async () => {
    const instagramRes = await GetInfoContentService({
      type: 'instagram_url',
    });

    const facebookRes = await GetInfoContentService({
      type: 'facebook_url',
    });

    const linkedinRes = await GetInfoContentService({
      type: 'linkedin_url',
    });

    if (instagramRes.status === 'success' && facebookRes.status === 'success' && linkedinRes.status === 'success') {
      form.setFieldsValue({
        instagram_url: instagramRes.data.content,
        facebook_url: facebookRes.data.content,
        linkedin_url: linkedinRes.data.content,
      });
    }
  };

  const handleSubmit = async (values) => {
    const updateContent = async (content, type) => {
      try {
        return await AddInfoContentService({ content, type });
      } catch (error) {
        return { error, type };
      }
    };

    const results = await Promise.all([
      updateContent(values.instagram_url, 'instagram_url'),
      updateContent(values.facebook_url, 'facebook_url'),
      updateContent(values.linkedin_url, 'linkedin_url'),
    ]);

    const allSuccess = results.every((res) => res.status === 'success');

    if (allSuccess) {
      await fetchData();
      message.success(trans('input_updated_successfully'));
    } else {
      results.forEach((res) => {
        if (res.error) {
          form.setFields([{
            name: res.type,
            errors: [res.error?.response?.data?.errors?.content],
          }]);
        }
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <SocialLinksForm
      form={form}
      handleSubmit={handleSubmit}
    />
  );
}

export default SocialLinks;
